import Head from 'next/head';
import CMSLayout from '../../../layouts/CMSLayout';
import {useRouter} from 'next/router';
import FullPageLoader from '@components/FullPageLoader';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import axios from '@lib/axios';
import {GetStaticPropsContext} from 'next';
import ImageCarousel from '@components/ImageCarousel';
import {ReferencePageTitle} from '@components/ReferencePageComponents/ReferencePageTitle';
import {APIRequestConfig} from '@enums/request-config';
import {CMSBreadcrumb, ContentContainer} from '@interfaces/content-container';
import {LocaleEnum} from '@enums/locale';
import {ImageInterface} from '@interfaces/images';
export default function ShowReferencePage({
  data,
}: {
  data: ContentContainer & {
    images: ImageInterface[];
  };
}) {
  const router = useRouter();
  if (router.isFallback) {
    return <FullPageLoader />;
  }

  const locale = router.locale as unknown as LocaleEnum;
  const pageTitle = data[`link_name_${locale}`];
  return (
    <CMSLayout
      parentContentId={data.parent_content_container_id!}
      contentId={data.second_location_identifier!}
      menu={data.menu}
      isReferencePage={true}
      breadcrumb={[
        ...data.breadcrumb,
        {[`link_name_${locale}`]: pageTitle} as CMSBreadcrumb,
      ]}
    >
      <Head>
        <title>{data[`seo_page_title_${locale}`]}</title>
        <meta
          name={'description'}
          content={data[`seo_description_${locale}`]}
          key={'description'}
        />
        <meta
          name={'keywords'}
          content={data[`seo_keywords_${locale}`]}
          key={'keywords'}
        />
      </Head>
      <div className="container">
        <ImageCarousel
          height={550}
          width={900}
          swipeSlide={false}
          images={data.images}
        />
        <ReferencePageTitle title={data[`link_name_${locale}`]} />
        {data.contents.map(content => {
          return (
            <div key={content.id} className="row">
              <div
                className="col-12 "
                dangerouslySetInnerHTML={{
                  __html: content[`column_div_3_${locale}`],
                }}
              ></div>
            </div>
          );
        })}
      </div>
    </CMSLayout>
  );
}

export async function getStaticProps({params, locale}: GetStaticPropsContext) {
  const {slug, contentContainerId} = params!;
  const data = await axios
    .get<any>(`pages/referencepage/${slug}/${contentContainerId}`, {
      headers: {[APIRequestConfig.X_LOCALE]: locale!},
    })
    .then(response => {
      return response.data.data;
    });

  const redirectUrl = data[`seo_redirect_url_${locale}`];
  if (redirectUrl) {
    return {
      redirect: {
        destination: redirectUrl,
        permanent: true,
      },
    };
  }
  return {
    props: {
      ...(await serverSideTranslations(locale!, ['common'])),
      data,
    },
    revalidate: 60,
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}
